var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Add New Addon Domain ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-alert",
            {
              attrs: {
                dense: "",
                dark: "",
                color: "primary"
              },
              scopedSlots: _vm._u([
                {
                  key: "prepend",
                  fn: function fn() {
                    return [
                      _c(
                        "v-icon",
                        {
                          staticClass: "mr-3",
                          attrs: {
                            size: "28",
                            color: "white"
                          }
                        },
                        [_vm._v("mdi-information-outline")]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(
                " An addon domain is an additional domain that the system stores as a subdomain of your main site. Use addon domains to host additional domains on your account. "
              )
            ]
          ),
          _c(
            "form",
            [
              _c("gg-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      excluded: _vm.hostingDomainsList,
                      required: true
                    },
                    expression:
                      "{ excluded: hostingDomainsList, required: true }"
                  }
                ],
                attrs: {
                  label: "New Domain Name",
                  name: "New Domain Name",
                  "error-messages": _vm.errors.collect("New Domain Name")
                },
                on: {
                  change: _vm.autocomplete
                },
                model: {
                  value: _vm.addonData.newdomain,
                  callback: function callback($$v) {
                    _vm.$set(_vm.addonData, "newdomain", $$v)
                  },
                  expression: "addonData.newdomain"
                }
              }),
              _c(
                "gg-btn",
                {
                  staticClass: "ml-0",
                  attrs: {
                    dark: "",
                    color: "green",
                    type: "submit",
                    tile: "",
                    loading: _vm.loading
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.addDomain($event)
                    }
                  }
                },
                [_vm._v("Add Domain ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }